/**
 * Mixin for shared warehouse filter computed properties and methods
 * Used by WarehouseFiltersDesktop and WarehouseFiltersMobile components
 */
export default {
  computed: {
    showItems() {
      return [
        {
          text: this.$t("meals_in_meals"),
          value: "daily",
        },
        {
          text: this.$t("meal_in_groops"),
          value: "daily-group",
        },
      ];
    },
    documentTypeItems() {
      return [
        { name: this.$t("all"), value: null },
        { name: this.$t("warehouse.request_quote"), value: "request" },
        { name: this.$t("warehouse.purchase_order"), value: "order" },
      ];
    },
    statusTypes() {
      return [
        { name: this.$t("all"), value: null },
        { name: this.$t("status_open"), value: "open" },
        { name: this.$t("status_created"), value: "created" },
        { name: this.$t("status_sent"), value: "sent" },
        { name: this.$t("status_confirmed_by_supplier"), value: "confirm" },
        {
          name: this.$t("status_partially_confirmed_by_supplier"),
          value: "confirm-half",
        },
        { name: this.$t("status_rejected_by_supplier"), value: "reject-supplier" },
        { name: this.$t("status_change_in_progress"), value: "changed-in-progress" },
        {
          name: this.$t("status_waiting_for_another_supplier"),
          value: "waiting-to-other-supplier",
        },
        { name: this.$t("status_rejected_by_us"), value: "reject" },
        { name: this.$t("delivered_11"), value: "delivered" },
        { name: this.$t("status_partially_delivered"), value: "delivered-half" },
        { name: this.$t("status_on_checking"), value: "on-checking" },
        { name: this.$t("status_rejected_on_arrival"), value: "reject-on-arrived" },
        { name: this.$t("status_accepted"), value: "accept" },
        { name: this.$t("status_closed"), value: "closed" },
        { name: this.$t("status_undefined"), value: "undefined" },
      ];
    },
    transactionTypes() {
      return [
        { text: this.$t("all"), value: null },
        { text: this.$t("warehouse.request_quote"), value: "request" },
        { text: this.$t("warehouse.purchase_order"), value: "order" },
        { text: this.$t("warehouse.warehouse_replenishment"), value: "entry" },
        { text: this.$t("warehouse.shipping_from_warehouse"), value: "exit" },
        { text: this.$t("warehouse.write_off"), value: "write-off" },
        { text: this.$t("warehouse.return_goods"), value: "return" },
      ];
    },
  },
  methods: {
    updateFilter(key, value) {
      this.$emit("update:filter", { key, value });
    },
  },
};
